import './multiplier-display.scss';

import { memo, useEffect, useRef } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from '@/app/store/hooks';
import { selectMultiplierState } from '@/entities/jetton';

import { createMultiplierPainter } from '../multiplier/painters';
import { useMultiplier } from '../multiplier/useMultiplier';

export const MultiplierDisplay = memo(() => {
  const { status, startTimeMs, crashMultiplier } = useAppSelector(
    selectMultiplierState,
    shallowEqual,
  );
  const engine = useMultiplier(status, startTimeMs, crashMultiplier);

  const valueRef = useRef<HTMLDivElement>(null);
  const statusRef = useRef(status);
  statusRef.current = status;

  // Whether the value element is mounted this render (flying/crashed only).
  const hasValueNode = status === 'flying' || status === 'crashed';

  // Bind a painter once the value element is mounted; it writes
  // value/tier/heartbeat per frame without re-rendering the component.
  useEffect(() => {
    const node = valueRef.current;
    if (node === null) return;

    const painter = createMultiplierPainter(
      node,
      () => statusRef.current === 'flying',
      () => statusRef.current === 'crashed',
    );

    return engine.subscribe(painter);
  }, [engine, hasValueNode]);

  return (
    <div className={`jmd status-${status}`}>
      {(status === 'flying' || status === 'crashed') && (
        <div
          ref={valueRef}
          className={`jmd__value ${status === 'crashed' ? 'tier-crashed' : ''}`}
        />
      )}

      {status === 'crashed' && (
        <span className="jmd__label jmd__label--crash jmd__label--in">CRASHED</span>
      )}
    </div>
  );
});
